import { render, staticRenderFns } from "./AccountPaymentSetting.vue?vue&type=template&id=c04484b2&scoped=true"
import script from "./AccountPaymentSetting.vue?vue&type=script&lang=js"
export * from "./AccountPaymentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04484b2",
  null
  
)

export default component.exports